import { supabase } from '../lib/supabase';

// Convert database snake_case to React camelCase
const convertToClientObject = (dbClient) => {
  if (!dbClient) return null;
  
  return {
    id: dbClient?.id,
    nombre: dbClient?.nombre,
    contacto: dbClient?.contacto,
    categoria: dbClient?.categoria,
    tarifaSinEmplatadoMenor: dbClient?.tarifa_sin_emplatado_menor,
    tarifaSinEmplatadoMayor: dbClient?.tarifa_sin_emplatado_mayor,
    tarifaEmplatado: dbClient?.tarifa_emplatado,
    activo: dbClient?.activo,
    createdAt: dbClient?.created_at
  };
};

export const clientService = {
  // Get all clients
  async getAll() {
    const { data, error } = await supabase
      ?.from('clientes')
      ?.select('*')
      ?.order('nombre', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(convertToClientObject);
  },

  // Get single client by ID
  async getById(id) {
    const { data, error } = await supabase
      ?.from('clientes')
      ?.select('*')
      ?.eq('id', id)
      ?.single();
    
    if (error) throw error;
    
    return convertToClientObject(data);
  },

  // Create new client
  async create(clientData) {
    const { data, error } = await supabase
      ?.from('clientes')
      ?.insert({
        nombre: clientData?.nombre,
        contacto: clientData?.contacto,
        categoria: clientData?.categoria,
        tarifa_sin_emplatado_menor: clientData?.tarifaSinEmplatadoMenor,
        tarifa_sin_emplatado_mayor: clientData?.tarifaSinEmplatadoMayor,
        tarifa_emplatado: clientData?.tarifaEmplatado,
        activo: clientData?.activo !== undefined ? clientData?.activo : true
      })
      ?.select()
      ?.single();
    
    if (error) throw error;
    
    return convertToClientObject(data);
  },

  // Update existing client
  async update(id, clientData) {
    const { data, error } = await supabase
      ?.from('clientes')
      ?.update({
        nombre: clientData?.nombre,
        contacto: clientData?.contacto,
        categoria: clientData?.categoria,
        tarifa_sin_emplatado_menor: clientData?.tarifaSinEmplatadoMenor,
        tarifa_sin_emplatado_mayor: clientData?.tarifaSinEmplatadoMayor,
        tarifa_emplatado: clientData?.tarifaEmplatado,
        activo: clientData?.activo
      })
      ?.eq('id', id)
      ?.select()
      ?.single();
    
    if (error) throw error;
    
    return convertToClientObject(data);
  },

  // Toggle active status
  async toggleActive(id, newStatus) {
    const { data, error } = await supabase
      ?.from('clientes')
      ?.update({ activo: newStatus })
      ?.eq('id', id)
      ?.select()
      ?.single();
    
    if (error) throw error;
    
    return convertToClientObject(data);
  },

  // Delete client
  async delete(id) {
    const { error } = await supabase?.from('clientes')?.delete()?.eq('id', id);
    
    if (error) throw error;
  }
};
